import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import GridRadioGroup from './GridRadioGroup';
import GridRadioButton from './GridRadioButton';
import Error from '../Error';

const renderError = (error, errortext = 'Veuillez renseigner ce champ.') => (
    error ? <Error errortext={errortext} forceerror /> : <p style={{ display: 'none' }} />
);

const GridRadioChoices = ({ choices, name, required, leftComponent, errortext, disabled, disabledChoices, fieldInfo, ...props }) => {
    const [desactive, setDesactive] = useState(false);
    const [isInputError, setIsInputError] = useState(false);

    useEffect(() => {
        if (false === navigator.onLine) {
            return setDesactive(true);
        }

        return setDesactive(false);
    }, [navigator.onLine]);

    useEffect(() => {
        setIsInputError(false);
    }, [name]);

    const verifieSiChoixDifferentsDesRipsUtilisateurs = (choix) => 'Tous les RIPs' === choix || 'RIPs à actualiser' === choix || 'Archivés' === choix;

    const doitEtreDesactive = (valeurChoix) => {
        if (verifieSiChoixDifferentsDesRipsUtilisateurs(valeurChoix) && true === desactive) {
            return true;
        }

        return false;
    };

    return (
        <GridRadioGroup
            name={name}
            {...props}
        >
            {Object.entries(choices).map(([key, value]) => (
                <GridRadioButton
                    required={required}
                    value={key}
                    label={value}
                    fieldInfo={'function' === typeof fieldInfo ? fieldInfo(key) : fieldInfo}
                    key={key}
                    leftComponent={leftComponent}
                    disabled={doitEtreDesactive(value) || disabled || disabledChoices.includes(key)}
                    setIsInputError={setIsInputError}
                    {...props}
                />
            ))}
            { renderError(isInputError, errortext)}
        </GridRadioGroup>
    );
};

GridRadioChoices.propTypes = {
    choices: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    disabledChoices: PropTypes.arrayOf(PropTypes.string),
    leftComponent: PropTypes.func,
    errortext: PropTypes.string,
    fieldInfo: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

GridRadioChoices.defaultProps = {
    required: false,
    disabledChoices: [],
    // explictly use undefined to allow the default value on GridRadioButton to be used instead
    leftComponent: undefined,
};

export default GridRadioChoices;
